import { render, staticRenderFns } from "./CustomerCompany.vue?vue&type=template&id=54115a68&scoped=true"
import script from "./CustomerCompany.vue?vue&type=script&lang=js"
export * from "./CustomerCompany.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54115a68",
  null
  
)

export default component.exports